exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".source-data{font-size:12px;color:rgba(51,51,51,.5);margin:1rem 0 2rem 0;display:block}", ""]);

// exports
